import { useContext } from "react";
import { type SessionSettings, SessionSettingsContext } from "src/contexts/SessionSettingsContext";
import type { SettingsContextValue } from "src/contexts/SettingsContext";

export const useSessionSettings = (): SettingsContextValue<SessionSettings> =>
    useContext(SessionSettingsContext);

export default useSessionSettings;
